import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { Loader, ThemeProvider, View, Text, Alert } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../material-snackbars';

import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
import './styles.css'
import { Button, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import { cancelFaceLivenessSession, createFaceLivenessSession, getFaceLivenessSessionResult, restartFaceLivenessSession } from '../../services/mexx-2-face/faceliveness.service';
import { createLivenessHistory } from '../../services/livenesshistory.service';
import { env } from '../../env';
import { Mexx2DOConsole } from '../../utils/mexxTalkConsole';
import ApiMexx2Face from '../../services/mexx-2-face/apiMexx2Face';
import GVCustomFaceLivenessDetector from '../gov-br-custom-face-liveness-detector';
import FaceRecognitionNear from '../images/face_recognition_near';
import FaceRecognitionFar from '../images/face_recognition_far';
import { ThemeContext } from '../../context/theme-context';
import GVButton from '../gov-br/button';

I18n.putVocabularies(translations);
I18n.setLanguage('pt');

class GVLivenessDeviceValidationInstructionsClass extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			openNotification: false,
			notificationVariant: 'error',
			notificationMessage: '',
		};

		this.closeNotification = this.closeNotification.bind(this);
	}

	componentWillReceiveProps(nextProps) {
	}

	componentDidMount() {
	}

	closeNotification() {
		this.setState({ openNotification: false });
	}

	render() {
		return (
			<div style={{ paddingLeft: 0, marginLeft: 0 }}>
				{this.state.loading ? (
					<Overlay>
						<CircularProgress color="primary" />
					</Overlay>
				) : (
					<>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<ThemeContext.Consumer>
									{({ theme }) => (
										<Typography variant="h2" className={this.props.class} style={theme === 'light' ? { color: '#1351b4', margin: 0 } : { color: '#FFF', margin: 0 }}>
											Para prosseguir, será necessário realizar a validação do seu dispositivo e logo após faremos a verificação de vida.
										</Typography>
									)}
								</ThemeContext.Consumer>
							</Grid>
							<Grid item xs={12}>
								<View flex="1">
									<Text>
										Durante este processo, será feita uma verificação para garantir que seu dispositivo atende aos requisitos mínimos, e Logo após faremos a verificação de vida. É importante autorizar o uso da câmera do dispositivo, pois realizaremos a leitura do seu rosto para continuar.
									</Text>
									<Alert
										variation="info"
										isDismissible={false}
										hasIcon={true}
										style={{ margin: '20px 0' }}>
										<strong>Validações de Segurança</strong><br />
										• <strong>Câmera:</strong> Física, 320x240px, 15 FPS<br />
										• <strong>Iluminação:</strong> Brilho 40-200, natural<br />
										• <strong>Rede:</strong> Mínimo 500 kbps, latência menor que 200ms
									</Alert>
									<Text style={{ marginBottom: '20px' }}>
										<strong>1. Leitura do rosto:</strong>
									</Text>
								</View>
								<Alert
									variation="warning"
									isDismissible={false}
									hasIcon={true}
									heading="Aviso de fotossensibilidade"
									style={{ color: '#A05D1A!important', backgroundColor: '#F5D9BC!important', marginBottom: '10px' }} >
									Esta verificação contém sequências de luzes que podem afetar pessoas fotossensíveis.
								</Alert>
								<View flex="1">
									<strong>Siga as instruções abaixo:</strong>
									<ol>
										<li>Esteja em uma área <strong>bem iluminada</strong> que não esteja exposta à luz solar direta;</li>
										<li><strong>Não cubra o rosto</strong> com óculos de sol, máscara ou demais adereços;</li>
										<li><strong>Maximize o brilho da tela</strong> de seu dispositivo para facilitar a leitura do rosto;</li>
										<li>Durante o processo, <strong>posicione o rosto na moldura oval</strong> até o final da contagem.</li>
									</ol>
									Siga o exemplo abaixo:
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<FaceRecognitionNear
											style={{ height: 150 }}
											divStyle={{ marginRight: 5 }} />
										<FaceRecognitionFar
											style={{ height: 150 }}
											divStyle={{ marginLeft: 5 }} />
									</div>
								</View>
								<div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
									<GVButton
										onClick={() => this.props.changeStep(4)}
										variant="contained"
										color="primary"
										label="Iniciar Pré-Validação" 
										>
										Iniciar Pré-Validação
									</GVButton>
								</div>
							</Grid>
						</Grid>
					</>
				)}
				<CustomizedSnackbars
					variant={this.state.notificationVariant}
					message={this.state.notificationMessage}
					isOpen={this.state.openNotification}
					toClose={this.closeNotification} />
			</div>
		);
	}
}

GVLivenessDeviceValidationInstructionsClass.propTypes = {
	changeStep: PropTypes.func
};

const mapStateToProps = state => ({
});

export default GVLivenessDeviceValidationInstructionsClass;

